export const TOAST_MSGS = {
  apiError: "Oops! Something went wrong. Try again.",
  submitReport: "Report submitted successfully",
  copied: "Copied to clipboard",
};
